import { Club } from '@/fairplayer/domain/club/Club';
import { euro } from '@/common/domain/token/Fiat';
import { ClubState } from '@/fairplayer/domain/club/ClubState';
import { BackendPartner, toPartner } from '@/fairplayer/secondary/club/BackendPartner';
import { Optional } from '@/common/domain/Optional';
import { LocalDate } from '@/common/domain/LocalDate';
import { BackendClubSummary, toClubSummary } from '@/fairplayer/secondary/club/BackendClubSummary';
import { Language } from '@/common/domain/Language';
import { ClubModel } from '@/fairplayer/domain/club/ClubModel';
import { BackendFiat, toFiat } from '@/common/secondary/token/BackendFiat';

export interface BackendClub {
  id: string;
  name: string;
  platformName: string;
  slug: string;
  model: ClubModel;
  logoUrl: string;
  bannerUrl: string;
  ticker: string;
  currentPrice: number;
  contactEmail: string;
  state: ClubState;
  eulaUrl: string;
  sfcUrl: string;
  privacyPolicyUrl: string;
  referralNeeded: boolean;
  coinsEnabled: boolean;
  fiatAccepted: boolean;
  promoteDonation: boolean;
  webappUrl: string;
  membershipFee?: BackendFiat;
  presentation?: string;
  upcomingDate?: string;
  languages: Language[];
  partners: BackendPartner[];
  linkedClubs: BackendClubSummary[];
}

export const toClub = (backendClub: BackendClub): Club => ({
  id: backendClub.id,
  name: backendClub.name,
  platformName: backendClub.platformName,
  slug: backendClub.slug,
  model: backendClub.model,
  logoUrl: backendClub.logoUrl,
  bannerUrl: backendClub.bannerUrl,
  ticker: backendClub.ticker,
  currentPrice: euro(backendClub.currentPrice),
  contactEmail: backendClub.contactEmail,
  state: backendClub.state,
  eulaUrl: backendClub.eulaUrl,
  sfcUrl: backendClub.sfcUrl,
  privacyPolicyUrl: backendClub.privacyPolicyUrl,
  referralNeeded: backendClub.referralNeeded,
  coinsEnabled: backendClub.coinsEnabled,
  fiatAccepted: backendClub.fiatAccepted,
  promoteDonation: backendClub.promoteDonation,
  webappUrl: backendClub.webappUrl,
  presentation: Optional.ofUndefinable(backendClub.presentation),
  upcomingDate: Optional.ofUndefinable(backendClub.upcomingDate).map(LocalDate.of),
  membershipFee: Optional.ofUndefinable(backendClub.membershipFee).map(toFiat),
  languages: backendClub.languages,
  partners: Optional.ofUndefinable(backendClub.partners).orElse([]).map(toPartner),
  linkedClubs: backendClub.linkedClubs.map(toClubSummary),
});
